import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { VDatePicker } from 'vuetify/components';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';

const LOCALE_ALIASES = {
    cz: 'cs',
    dk: 'da',
    se: 'sv',
    gr: 'el',
    nb: 'no',
    nn: 'no',
};

const SUPPORTED_LOCALES = new Set([
    'af', 'ar', 'az', 'bg', 'ca', 'ckb', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fa', 'fi',
    'fr', 'he', 'hr', 'hu', 'id', 'it', 'ja', 'km', 'ko', 'lt', 'lv', 'nl', 'no', 'pl', 'pt',
    'ro', 'ru', 'sk', 'sl', 'sr', 'sv', 'th', 'tr', 'uk', 'vi', 'zh',
]);

export function resolveVuetifyLocale(code) {
    const raw = String(code || '').toLowerCase().trim();
    if (!raw) return 'en';

    const normalized = raw.replace('_', '-');
    const base = normalized.split('-')[0] || 'en';
    const mapped = LOCALE_ALIASES[base] || base;

    if (SUPPORTED_LOCALES.has(mapped)) return mapped;
    return 'en';
}

const initialLocale = typeof window !== 'undefined'
    ? resolveVuetifyLocale(window.__APP_DATA__?.lang?.code)
    : 'en';

const vuetify = createVuetify({
    components: {
        VDatePicker,
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: { mdi },
    },
    locale: {
        locale: initialLocale,
        fallback: 'en',
    },
});

export default vuetify;
